var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevroneUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.525 9.4999L19.875 16.8499C20.125 17.0999 20.4167 17.2207 20.75 17.2124C21.0833 17.2041 21.375 17.0749 21.625 16.8249C21.875 16.5749 22 16.2832 22 15.9499C22 15.6166 21.875 15.3249 21.625 15.0749L13.95 7.3749C13.75 7.1749 13.525 7.0249 13.275 6.9249C13.025 6.8249 12.775 6.7749 12.525 6.7749C12.275 6.7749 12.025 6.8249 11.775 6.9249C11.525 7.0249 11.3 7.1749 11.1 7.3749L3.40001 15.0749C3.15001 15.3249 3.02918 15.6207 3.03751 15.9624C3.04585 16.3041 3.17501 16.5999 3.42501 16.8499C3.67501 17.0999 3.96668 17.2249 4.30001 17.2249C4.63335 17.2249 4.92501 17.0999 5.17501 16.8499L12.525 9.4999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevroneUp);
export default __webpack_public_path__ + "static/media/ChevroneUp.1c3ccb2d20383cb22c1aad996c360a27.svg";
export { ForwardRef as ReactComponent };